import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ContactPage } from "@/features/contactpage/ContactPage";

const search = z.object({
  tab: z.string().optional(),
});

export const Route = createFileRoute("/_app/contacts/$contact")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { contact } = Route.useParams();
  return <ContactPage id={contact} search={Route.useSearch()} />;
}
